export default import.meta.ROLLDOWN_FILE_URL__$uMPRI__Y7tVr1bvVtHJg